import React from 'react';
import {
  KompisFakeData,
  KompisPrompt,
} from '@inter-ikea-kompis/react-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { PromptButtonTypeEnum } from '@inter-ikea-kompis/component-prompt';

export default class FakeData extends React.Component {
  constructor() {
    super();
    this.state = {
      visible: true,
    };
  }

  onApplyChanges(e) {
    window.sessionStorage.setItem(
      'FakeData',
      JSON.stringify(e.detail.updatedProducts)
    );
    window.location.reload();
  }

  isPrimaryButtonEvent = type => type === PromptButtonTypeEnum.primaryButton;

  closeClick = () => {
    this.setState({ visible: false });
  };

  handleButtonClick = ({ detail: { type } }) =>
    this.isPrimaryButtonEvent(type) && this.closeClick();

  render() {
    return (
      <KompisPrompt
        visible={this.state.visible}
        disableIframeSticky={true}
        theme={SkapaTheme}
        primaryButtonLabel={'Close'}
        onButtonClick={this.handleButtonClick}
      >
        <KompisFakeData
          products={this.props.products}
          theme={SkapaTheme}
          onApplyChanges={e => this.onApplyChanges(e)}
        />
      </KompisPrompt>
    );
  }
}
